import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, X } from "lucide-react";
import { Button } from "./ui/button";
import {
  CURRENT_RELEASE_MONTH_ID,
  hasSeenReleaseNotes,
  markReleaseNotesSeen,
} from "../config/releaseNotes";

export default function ReleaseNotesBanner() {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(() => !hasSeenReleaseNotes());

  if (!visible) return null;

  const dismiss = () => {
    markReleaseNotesSeen();
    setVisible(false);
  };

  const handleView = () => {
    markReleaseNotesSeen();
    setVisible(false);
    navigate("/novita");
  };

  return (
    <div
      className="relative mb-4 rounded-2xl border border-emerald-200/80 bg-white/90 backdrop-blur-sm shadow-[0_4px_24px_rgba(16,185,129,0.12)] ring-1 ring-emerald-100 overflow-hidden"
      data-testid="release-notes-banner"
      data-release-id={CURRENT_RELEASE_MONTH_ID}
    >
      <div className="absolute inset-y-0 left-0 w-1 bg-gradient-to-b from-emerald-400 to-teal-500" aria-hidden="true" />

      <div className="flex items-start sm:items-center gap-3 sm:gap-4 p-4 pr-10 sm:pr-4">
        <div className="hidden sm:flex flex-shrink-0 w-11 h-11 rounded-xl bg-gradient-to-br from-emerald-50 to-teal-50 border border-emerald-100 items-center justify-center">
          <Sparkles className="w-5 h-5 text-emerald-600" />
        </div>

        <div className="flex-1 min-w-0">
          <p className="text-sm sm:text-base font-semibold text-slate-900 leading-snug">
            ✨ Sono disponibili nuovi aggiornamenti di giugno
          </p>
          <p className="text-xs sm:text-sm text-slate-500 mt-0.5">
            Scopri tutte le novità e i miglioramenti rilasciati nel sistema.
          </p>
        </div>

        <Button
          onClick={handleView}
          className="flex-shrink-0 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl px-4 h-9 text-sm font-semibold shadow-sm"
          data-testid="release-notes-banner-cta"
        >
          Visualizza novità
        </Button>
      </div>

      <button
        type="button"
        onClick={dismiss}
        className="absolute top-3 right-3 p-1 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
        aria-label="Chiudi banner novità"
        data-testid="release-notes-banner-dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
